import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../store/store';
import {
  addItemToLocalCart,
  removeItemFromLocalCart,
  updateItemQuantityInLocalCart,
  clearCartInLocalCart,
  getAllItemsInLocalCart,
  selectCartItems,
  selectCartItemCount,
  selectCartTotal,
  selectCartItemsCount,
  TLocalCartItem,
  updateItemPriceInLocalCartById,
} from '../store/localCart';

export const useLocalCart = () => {
  const dispatch = useAppDispatch();
  const items = useAppSelector(selectCartItems);
  const itemCount = useAppSelector(selectCartItemCount);
  const total = useAppSelector(selectCartTotal);
  const itemsCount = useAppSelector(selectCartItemsCount);

  const addItemToCart = useCallback(
    (item: TLocalCartItem) => {
      dispatch(addItemToLocalCart(item));
    },
    [dispatch]
  );

  const removeItem = useCallback(
    (id: string) => {
      dispatch(removeItemFromLocalCart(id));
    },
    [dispatch]
  );

  const updateQuantity = useCallback(
    (id: string, quantity: number) => {
      dispatch(updateItemQuantityInLocalCart({ id, quantity }));
    },
    [dispatch]
  );

  const updatePrice = useCallback(
    (id: string, price: number) => {
      dispatch(updateItemPriceInLocalCartById({ id, price }));
    },
    [dispatch]
  );

  const clearAll = useCallback(() => {
    dispatch(clearCartInLocalCart());
  }, [dispatch]);

  const refreshFromStorage = useCallback(() => {
    dispatch(getAllItemsInLocalCart());
  }, [dispatch]);

  const getItemById = useCallback(
    (id: string) => {
      return items.find((item) => item.id === id);
    },
    [items]
  );

  return {
    items,
    itemCount,
    total,
    itemsCount,
    addItemToCart,
    removeItem,
    updateQuantity,
    updatePrice,
    clearAll,
    refreshFromStorage,
    getItemById,
  };
};
